import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 03 de diciembre de 2025
 */

const RowCardList = ({leftPart,centerPart,rightPart,className='',
                               classNameColors= 'background-shades-50 border-full-shades-100 background-hover-secondary-50'}) => {

    return (
        <div className={`row ${className} justify-content-start align-items-center border-radius-8px my-2 ${classNameColors} `}>
            <div className={`col-6 d-flex justify-content-start align-items-center gap-2 p-0 m-0`}>
                { leftPart }
            </div>

            { centerPart &&
                <div className={`${ centerPart && rightPart ? 'col-3' : 'col-6'}  p-0 d-flex justify-content-start align-items-center gap-2`}>
                    { centerPart }
                </div>
            }

            { rightPart &&
                <div className={`${ centerPart && rightPart ? 'col-3' : 'col-6'}  d-flex justify-content-end align-items-center`}>
                    { rightPart }
                </div>
            }
        </div>
    )
}

export default RowCardList
